import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {BrowserRouter} from "react-router-dom";
import "./i18n";
import {Provider} from "react-redux";
import store from "./store";
import VariableProvider from "./components/HOC/variable-provider";

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <VariableProvider>
                <App/>
            </VariableProvider>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();